/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function (Flits) {
  /* To load js in all pages */
  if (
    Flits.Metafields.IS_SOCIAL_LOGIN_PAID &&
    Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE
  ) {
    if (window.flitsObjects.allCssJs.socialLoginJs) {
      Flits.LoadStyleScript(
        "socialLoginJs",
        window.flitsObjects.allCssJs.socialLoginJs.url
      );
    }
  }

  Flits(document).on("Flits:Navigation:Loaded", function (event) {
    var settings = event.detail.settings;
    var obj = {
      title: "My Downloads",
      url: "#downloads",
      target: 0,
      badge: null,
      icon: null,
      isShow: 1,
      loader: null,
      body_html: '<div id="flits-custom-content"></div>',
    };
    settings.navs.splice(2, 0, obj);
  });

  setInterval(function(){
    let pbLink = Flits('.pb-mydownloads-paginate-link a');
    if(pbLink){
        Flits(pbLink).each(function (i, ele) {
          let currentHref = Flits(ele).attr('href');
          if(currentHref && !currentHref.includes('#downloads')){
            let newHref = currentHref + '#downloads';
            Flits(ele).attr('href', newHref);
          }
      });
    }
  }, 3000)

  Flits(document).on("Flits:Navigation:Loaded", function (event) {
    if (window.flitsObjects.storeData.should_store_credit_work != true) {
      var settings = event.detail.settings;
      var listToDelete = ["manage my subscription"];
      for (var i = 0; i < settings.navs.length; i++) {
        var obj = settings.navs[i];
        if (listToDelete.indexOf(obj.title) != -1) {
          settings.navs[i].isShow = 0;
        }
      }
    }
  });

  function flitsCustomIntregation() {
    var integrated_page = Flits(".flits-custom-page").children();
    Flits("#flits_tab_downloads #flits-custom-content").append(integrated_page);
    Flits(".flits-custom-page").remove();
  }

  Flits(document).on("Flits:AccountPage:Loaded", function (event) {
    setTimeout(function () {
      flitsCustomIntregation();
    }, 1000);
  });
})(Flits);
